import * as types from "./mutation-type";

export default {}
